import { isEmail } from './is-email';
import { isPhonenumber } from './is-phone-number';
export var validateWithType = function (type, value) {
    if (type === 'containChars10') {
        return value && value.trim().length >= 10;
    }
    else if (type === 'containChars20') {
        return value && value.trim().length >= 20;
    }
    else if (type === 'containChars30') {
        return value && value.trim().length >= 30;
    }
    else if (type === 'containNumbers') {
        return /[0-9]{6,}/.test(value);
    }
    else if (type === 'email') {
        return isEmail(value);
    }
    else if (type === 'phonenumber') {
        return isPhonenumber(value);
    }
    else {
        return true;
    }
};
